import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Services } from "@/components/landing/Services";
import { WhyKrono } from "@/components/landing/WhyKrono";
import { Safety } from "@/components/landing/Safety";
import { Portfolio } from "@/components/landing/Portfolio";
import { Banner } from "@/components/landing/Banner";
import { Coverage } from "@/components/landing/Coverage";
import { PackTeaser } from "@/components/landing/PackTeaser";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";
import { useLenis } from "@/hooks/useLenis";

export default function LandingPage() {
  useLenis();
  return (
    <div data-testid="landing-page" className="bg-black text-white">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WhyKrono />
        <Safety />
        <Banner />
        <Portfolio />
        <Coverage />
        <PackTeaser />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
